// Copyright (c) 2017 Deere & Company

import * as sharedClaimTypesActionCreator from '../../../shared/action-creators/get-claim-types';
import actions from '../../action-list';

export const readClaimTypes = () => sharedClaimTypesActionCreator.readClaimTypes(actions.UPDATE_CLAIMS_IN_PROGRESS_CLAIM_TYPES);



// WEBPACK FOOTER //
// ./src/claim/claims-in-progress/action-creators/get-claim-types.js